import { Node } from '@tiptap/core';

export const PageBreakDocument = Node.create({
  name: 'doc',
  topNode: true,
  content: '(pageBreak? block)+ pageBreak?',
  allowGapCursor: true,
});
